import React from 'react';
import WoTotalPrice from './WoTotalPrice';
import WoTotalPriceWAdCharge from './WoTotalPriceWAdCharge';

const Table2WorkorderDetails = ({workorderData}) => {
    return (
        <>

            <div className='mx-1'>

                <table className='table-auto border-2 border-[#ED6C6C] border-collapse max-w-[100%] text-[12px] '>

                    <thead>

                        <tr className='bg-[#EEEEEE]'>

                            <th className='border-2 border-[#ED6C6C] w-[800px] py-3'> PRICE SUMMERY</th>

                        </tr>

                    </thead>



                    <tbody className='text-center'>



                        <tr>
                            <td className='border-2 border-[#ED6C6C] w-[800px] py-3 '>
                                <div className='flex'>
                                    <div className='w-[50%]'>Total Price </div>
                                    <div className='w-[8%]'> + </div>
                                    <div className='w-[42%]'> <WoTotalPrice workorderData={workorderData} /> </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="" className='border-2 border-[#ED6C6C] w-[800px] py-3'>
                                <div className='flex'>
                                    <div className='w-[50%]'>Transport Charge </div>
                                    <div className='w-[8%]'> + </div>
                                    <div className='w-[42%]'> {workorderData?.transport_charge} </div>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td colSpan="" className='border-2 border-[#ED6C6C] w-[800px] py-3'>
                                <div className='flex'>
                                    <div className='w-[50%]'>Other Charge  </div>
                                    <div className='w-[8%]'> + </div>
                                    <div className='w-[42%]'> {workorderData?.other_charge} </div>
                                </div>

                            </td>
                        </tr>

                        <tr>
                            <td colSpan="" className='border-2 border-[#ED6C6C] w-[800px] py-3'>
                                <div className='flex'>
                                    <div className='w-[50%]'>Add Discount   </div>
                                    <div className='w-[8%]'> - </div>
                                    <div className='w-[42%]'> {workorderData?.additional_discount} </div>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td colSpan="" className='border-2 border-[#ED6C6C] w-[800px] py-3'>
                                <div className='flex'>
                                    <div className='w-[50%]'>Final Amount  </div>
                                    <div className='w-[8%]'> = </div>
                                    <div className='w-[42%]'> <WoTotalPriceWAdCharge workorderData={workorderData} /> </div>
                                </div>

                            </td>
                        </tr>












                    </tbody>

                </table>



            </div>

        </>
    );
};

export default Table2WorkorderDetails;